import React, {useState} from 'react';
import more from '../../../Assets/icons/more_horiz.svg'
import cl from './More.module.css'
import {useNavigate} from "react-router-dom";
import Service from "../../../API/Service";
import MyModal from "../MyModal/MyModal";

const More = ({id, entity, isOpen, onToggle, setCourses}) => {
    const navigate = useNavigate();
    const [modal, setModal] = useState(false);

    const deleteText = 'Are you sure you want to delete this course? This action cannot be undone.';
    const btnText = "Delete";

    const handleDelete = async () => {
        try {
            await Service.deleteItem(entity, id);
            setCourses(prevData => prevData.filter(item => item.id !== id));
            setModal(false);
        } catch (error) {
            console.error("Ошибка при удалении:", error);
        }
    };

    return (
        <div onClick={onToggle} className={cl.wrap}>
            <MyModal
                text={deleteText}
                btnText={btnText}
                visible={modal}
                setVisible={setModal}
                onClick={handleDelete}
            />
            <img src={more} alt={"ne znayu"}/>
            {isOpen && (
                <div className={cl.menu}>
                    <div className={cl.edit}>
                        Manage students
                    </div>
                    <div className={cl.edit}>
                        Manage modules
                    </div>
                    <div
                        className={cl.edit}
                        onClick={() => {navigate(`/${entity}/${id}`)}}
                    >
                        View details
                    </div>
                    <div
                        className={cl.edit}
                        onClick={() => {navigate(`/${entity}/${id}/edit`)}}
                    >
                        Edit
                    </div>
                    <div
                        className={cl.delete}
                        onClick={() => {setModal(true)}}
                    >
                        Delete
                    </div>
                </div>
            )}
        </div>
    );
};

export default More;